import { ModuleDefault } from '../default';

export class Create extends ModuleDefault {
    public acceptAll (body = {}) {
        return this.request.post(`${this.setup.urlBase}/invites/accept/all`, body);
    }
}
